import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ThemePalette } from '@angular/material/core';

export type ButtonAppearance =
  | 'button'
  | 'raised'
  | 'flat'
  | 'stroked'
  | 'icon'
  | 'fab'
  | 'mini-fab';

@Component({
  selector: 'bn-button',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatButtonModule, MatIconModule, NgTemplateOutlet],
  styleUrl: './button.component.scss',
  template: `
    @switch (appearance()) {
      @case ('raised') {
        <button
          mat-raised-button
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @case ('flat') {
        <button
          mat-flat-button
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @case ('stroked') {
        <button
          mat-stroked-button
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @case ('icon') {
        <button
          mat-icon-button
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @case ('fab') {
        <button
          mat-fab
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @case ('mini-fab') {
        <button
          mat-mini-fab
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
      @default {
        <button
          mat-button
          [color]="color()"
          [disabled]="disabled()"
          [type]="type()"
        >
          <ng-container *ngTemplateOutlet="content"></ng-container>
        </button>
      }
    }

    <ng-template #content>
      <span class="bn-button-content">
        @if (icon()) {
          <mat-icon>{{ icon() }}</mat-icon>
        }
        <ng-content></ng-content>
      </span>
    </ng-template>
  `,
})
export class ButtonComponent {
  disabled = input(false);
  type = input<'submit' | 'button' | 'reset'>('button');
  appearance = input<ButtonAppearance>('button');
  color = input<ThemePalette>(undefined); // Default to undefined (primary/accent/warn not set)
  icon = input<string | undefined>(undefined);
}
